<template>
  <div class="liu">
    <!-- title -->
    <mt-header fixed title="优惠收款交易明细" class="title1">
      <mt-button slot="left" icon="back" @click="onGoBackClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 空页 -->
      <div v-if="isEmptyData"></div>
      <!-- 任务列表 -->
      <div v-if="isHasData" class="reward-pay-list">
        <div class="pay-list-item" v-for="(item, index) in myData.list" :key="index">
          <div class="item-logo">
            <img :src="require('../assets/reward@3x.png')" width="40" height="40" />
          </div>
          <div class="item-content">
            <div class="content-text">
              {{ item.userName }} 收款码交易{{ item.payMoney | money }} 商户获取奖励{{ item.money | money }}
            </div>
            <div class="content-date">{{ item.insertDate }}</div>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isNoData">
        <div class="no-data">
          <img src="../assets/bitmap_reward@3x.png" width="60%" />
          <div class="title-5" v-if="myParam.productAgentId">此代理商暂无商户奖励明细</div>
          <div class="title-5" v-else>{{ emptyStartDate + " - " + emptyEndDate + " 暂无商户奖励明细" }}</div>
          <div class="title-5"> 点击右上角 <span @click="visible.search = true">更多</span> 查看更多商户奖励明细 </div>
        </div>
      </div>
    </div>
    <!-- 查询弹出框 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="top" popup-transition="popup-fade">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 商户名 -->
          <div class="content-box">
            <div>
              <span>商户名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="search.user.selected" placeholder="请选择商户名称或手机号" readonly @click="onUserTextClick" />
              <img v-show="!search.user.empty" :src="require('@/assets/clear.png')" alt @click="onUserClearBtnClick" />
            </div>
          </div>
          <!-- 奖励时间 -->
          <div class="content-box">
            <div>
              <span>奖励时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchCancelClick">取消</span>
          <span class="blue" @click="onSearchOkClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 商户名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.user" position="right" :modal="false">
      <mt-header fixed title="选择商户" class="title2">
        <mt-button slot="left" icon="back" @click="visible.user = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <mt-search v-model="search.user.key" @keyup.enter.native="onUserTableSearchClick" cancel-text="取消" placeholder="输入商户姓名或手机号" :show="true">
            <div class="result-list">
              <div class="list-row">
                <div class="list-item" v-for="(item, index) in search.user.list" :key="index" @click="onUserTableSelectedClick(item)">
                  <span>{{ item.userName + " " + item.mobile }}</span>
                </div>
              </div>
            </div>
          </mt-search>
        </form>
      </div>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { GetUserPayRewardList } from '@/api/user';
import { GetUserByMobileOrName, DateBase } from '@/api/agent';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';
import { Indicator } from 'mint-ui';

export default {
  name: 'TaskReward',
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      // 列表信息
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        userId: '',
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 查询数据
      search: {
        // 商户名
        user: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
      },
      // 显示开关
      visible: {
        search: false,
        user: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'taskrewarddetail') {
      this.$store.commit('setCache', 'TaskReward');
    } else {
      this.$store.commit('delCache', 'TaskReward');
    }
    next();
  },
  mounted() {
    this.initData();
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isEmptyData() {
      return this.myData.total === -1;
    },
    isHasData() {
      return this.myData.total > 0;
    },
    isNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.$nextTick(() => {
        this.getDateBase(this.getMyData);
      });
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      // 设置时间
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      // 查询
      GetUserPayRewardList(this.myParam)
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              console.log(res);
              this.myData.total = res.total;
              if (res.data.list) this.myData.list.push(...res.data.list);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 交互后返回代理商列表
    getUserListBox(nameOrMobile = '', callback = null) {
      Indicator.open();
      GetUserByMobileOrName({ nameOrMobile })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.search.user.list = res.rows;
              document.activeElement.blur();
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 交互后返回日期查询条件
    getDateBase(callback = null) {
      DateBase({ interfaceName: '/app/User/GetUserPayRewardList' })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.picker.startDateBase = res.data.startDate.split(' ')[0];
              this.picker.endDateBase = res.data.endDate.split(' ')[0];
              this.picker.startDateText = this.picker.startDateBase;
              this.picker.endDateText = this.picker.endDateBase;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 查询搜索取消事件
    onSearchCancelClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 查询搜索单击事件
    onSearchOkClick() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 1.关闭查询窗口
      this.visible.search = false;
      // 2.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 3.重置列表数据
      this.myData.list = [];
      // 4.重置翻页页数
      this.myParam.pageNum = 1;
      // 5.重置总数
      this.myData.total = -1;
      // 6. 加载数据
      this.getMyData();
    },
    // 单击日期事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 返回按钮事件
    onGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 日期确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // 筛选窗口名称点击事件
    onUserTextClick() {
      this.getUserListBox('', () => {
        this.visible.user = true;
        this.search.user.key = '';
      });
    },
    // 清空筛选框中名称的事件
    onUserClearBtnClick() {
      this.search.user.selected = '';
      this.myParam.userId = '';
      this.search.user.empty = true;
    },
    // 名称列表商户名称查询事件
    onUserTableSearchClick() {
      this.getUserListBox(this.search.user.key);
    },
    // 列表选中商户名称事件
    onUserTableSelectedClick(item) {
      this.search.user.selected = `${item.userName} ${item.mobile}`;
      this.myParam.userId = item.userId;
      this.search.user.empty = false;
      this.visible.user = false;
    },
    // 置空所有筛选窗口数据
    clearSearchData() {
      this.search.user.empty = true;
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
    },
  },
  filters: {
    moeny(val) {
      if (val) {
        return parseFloat(val / 100)
          .toFixed(2)
          .toString();
      } else {
        return '0.00';
      }
    },
  },
};
</script>
